export default __webpack_public_path__ + "static/media/mealprep.1d92a30f.mp4";